export { default } from "./routes/datenschutz.tsx";